/* eslint-disable react/require-default-props */
import React from 'react'
import { createUseStyles } from 'react-jss'
import { colors } from '../../../theme/palette'

type Props = {
    icon: JSX.Element
    message?: string
}

const useStyles = createUseStyles(() => ({
    row: () => {
        return {
            position: 'relative',
            backgroundColor: colors.white,
            color: 'black',
            marginBottom: '1rem',
            borderRadius: '4px',
            width: '700px',
            maxWidth: '100%',
            padding: '3.375rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
        }
    },
    icon: {
        position: 'absolute',
        top: '-31px',
    },
    message: {
        fontSize: '1rem',
        marginTop: '1.5rem',
        maxWidth: '400px',
        textAlign: 'center',
    },
}))

const CardWithIconAndMessge: React.FC<Props> = ({
    children,
    icon,
    message,
}) => {
    const classes = useStyles()

    return (
        <div className={classes.row}>
            <div className={classes.icon}>{icon}</div>
            {message ? <div className={classes.message}>{message}</div> : null}
            {children}
        </div>
    )
}

export { CardWithIconAndMessge }
